export { default } from "./useLazyContentPromotionFormsGet";
